module.exports = __webpack_public_path__ + "static/99-595fa6974268ba198cf4739f5e6eda64.png";